import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { Perfil } from '../../../types/Perfil.type';
import { PerfilService } from './perfil.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css'
})
export class PerfilComponent implements OnInit {

  perfis!: Perfil[]
  perfil!: Perfil
  perfilDialog: boolean = false

  constructor(private perfilService: PerfilService, private toastService: ToastService) {}

  ngOnInit(){
    this.perfilService.getAll().subscribe({
      next: (value) => {
        this.perfis = value
      },
      error(err) {
        
      },
    })
  }

  abrePerfilDialog(perfilParam?: Perfil){
    this.perfil = {} as Perfil;

    if(perfilParam) this.perfil = perfilParam;
    
    this.perfilDialog = true;
  }


  fechaPerfilDialog(){
   this.perfilDialog = false;
  }
}
